<div class="d-flex w-100 justify-content-start">
  <div class="me-3">
    <i class="fas fa-plus-circle text-success"></i>
  </div>
  <div i18n="@@collection.config.tab.rules.add">
    Add a new automation
  </div>
</div>

